<template>
    <div class="a-form-inputs--half a-form-inputs--half-to">
        <div class="a-form-inputs__container">
            <input v-model="fromReserve" />
        </div>
        <div class="a-form-inputs__to">to</div>
        <div class="a-form-inputs__container">
            <input v-model="toReserve" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "dates",
        components: {
            
        },
        computed: {
            fromReserve: {
                get() {
                    return this.$store.getters['dashboards/fromReserve'];
                },
                set(value) {
                    this.$store.dispatch('dashboards/updateFilter', {filter: 'fromReserve', value})
                }
            },
            toReserve: {
                get() {
                    return this.$store.getters['dashboards/toReserve'];
                },
                set(value) {
                    this.$store.dispatch('dashboards/updateFilter', {filter: 'toReserve', value})
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ReserveRange.vue?20868b21